(function() {
	'use strict';
	angular.module('sideApp')
	.factory('showdownloadpage', showdownloadpage);

	showdownloadpage.$inject = [ '$resource' ];

	function showdownloadpage ($resource) {
		var resourceUrl = 'apo/alumosquecontestaron/:ambito';

		return $resource(resourceUrl, {}, {
			'get' : {
				method : 'GET',
//				isArray : true
				transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
			},
//			'getNumAlumnosQueContestaronSI': {
//                url:'apo/alumnosquecontestaronsi/:ambito',
//                method: 'GET',
//                transformResponse: function (data) {
//                    return {'total' : data};
//                }
//            },
		});
	}
})();